import React, { FC } from 'react';
import { Button, Stack, Typography } from '@mui/material';
import styles from './BookingComponent.module.scss';

interface BookingComponentProps {
    handleClose?: () => void;
}

const BookingComponent: FC<BookingComponentProps> = (props) => {
    const { handleClose } = props;

    return (
        <div className={styles.BookingComponent} data-testid="BookingComponent">
            <Stack
                spacing={2}
                sx={{
                    justifyContent: 'space-between',
                    height: '100%',
                }}
            >
                <div />
                <Stack
                    spacing="20px"
                >
                    <Typography
                        sx={{
                            textAlign: 'center',
                            fontFamily: 'Poppins',
                            fontWeight: '600',
                            fontSize: '22px',
                        }}
                    >
                        For demonstration only
                    </Typography>
                    <Typography
                        sx={{
                            textAlign: 'center',
                            fontFamily: 'Poppins',
                            fontWeight: '400',
                            fontSize: '20px',
                            lineHeight: '26px',
                        }}
                    >
                        Activation will require administrator authority.
                    </Typography>
                </Stack>
                <Button
                    variant="contained"
                    onClick={handleClose}
                    sx={{
                        borderRadius: '48px',
                        height: '69px',
                    }}
                >
                    OK
                </Button>
            </Stack>
        </div>
    );
};

BookingComponent.defaultProps = {
    handleClose: undefined,
};
export default BookingComponent;
